module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/my-account/my-account.component.css
// module id = ./src/app/admin/my-account/my-account.component.css
// module chunks = main